import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowLeft, ArrowRight, X, CheckCircle } from "@phosphor-icons/react";

export default function CookMode() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recipe, setRecipe] = useState(null);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get(`/recipes/${id}`).then((r) => setRecipe(r.data)).catch(() => navigate("/app"));
  }, [id, navigate]);

  if (!recipe) return null;
  const total = recipe.steps.length;
  const step = recipe.steps[idx];
  const done = idx >= total;

  const prev = () => setIdx((i) => Math.max(0, i - 1));
  const next = () => setIdx((i) => Math.min(total, i + 1));

  return (
    <div className="fixed inset-0 bg-[hsl(var(--background))] z-50 flex flex-col" data-testid="cook-mode">
      <div className="flex items-center justify-between p-6">
        <button onClick={() => navigate(`/app/recipe/${id}`)} data-testid="cook-exit-btn" className="inline-flex items-center gap-2 text-sm text-[hsl(var(--muted-foreground))]">
          <X size={20} /> Salir
        </button>
        <p className="font-serif italic text-lg">{recipe.title}</p>
        <p className="text-sm text-[hsl(var(--muted-foreground))]">{done ? total : idx + 1} / {total}</p>
      </div>

      {/* progress bar */}
      <div className="h-1 bg-[hsl(var(--muted))] mx-6 rounded-full overflow-hidden">
        <div className="h-full bg-[hsl(var(--primary))] transition-all duration-500" style={{ width: `${(Math.min(idx + 1, total) / total) * 100}%` }} />
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="max-w-3xl w-full text-center">
          {!done ? (
            <>
              <p className="step-num text-7xl md:text-8xl">{String(step.order).padStart(2, "0")}</p>
              <p className="mt-8 font-serif text-3xl md:text-5xl leading-tight tracking-tight" data-testid="cook-step-text">{step.text}</p>
            </>
          ) : (
            <div className="fade-up">
              <CheckCircle size={80} weight="duotone" className="mx-auto text-[hsl(var(--secondary))]" />
              <p className="mt-6 font-serif text-5xl">¡Listo!</p>
              <p className="mt-3 text-[hsl(var(--muted-foreground))]">Disfruta tu {recipe.title.toLowerCase()}.</p>
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center justify-between p-6 gap-4">
        <button
          onClick={prev}
          disabled={idx === 0}
          data-testid="cook-prev-btn"
          className="px-6 py-4 rounded-full bg-white border border-[hsl(var(--border))] btn-press inline-flex items-center gap-2 disabled:opacity-30"
        >
          <ArrowLeft size={20} /> Anterior
        </button>
        {!done ? (
          <button onClick={next} data-testid="cook-next-btn" className="flex-1 max-w-xs px-6 py-4 rounded-full bg-[hsl(var(--primary))] text-white font-semibold btn-press hover-lift inline-flex items-center justify-center gap-2">
            {idx === total - 1 ? "Terminar" : "Siguiente"} <ArrowRight size={20} weight="bold" />
          </button>
        ) : (
          <button onClick={() => navigate(`/app/recipe/${id}`)} data-testid="cook-finish-btn" className="flex-1 max-w-xs px-6 py-4 rounded-full bg-[hsl(var(--foreground))] text-white font-semibold btn-press">
            Volver a la receta
          </button>
        )}
      </div>
    </div>
  );
}
